import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { typography } from '@shared/tokens/typography.stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: fonts.din2014Regular,
    ':not(#__unused__) input': {
      fontSize: typography['fontSizeCaption-1'],
      lineHeight: typography['lineHeightCaption-1'],
      height: anatomy['size-36'],
    },
    ':not(#__unused__) div:has(> input) > div': {
      fontSize: typography['fontSizeCaption-2'],
      lineHeight: typography['lineHeightCaption-2'],
      height: 'auto',
      position: 'static',
      marginBottom: anatomy['size-4'],
    },
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    minHeight: '474px',
  },

  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  header: {
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-4'],
    lineHeight: typography['lineHeightBody-1'],
    fontFamily: fonts.din2014Demi,
    width: '100%',
    height: anatomy['space-48'],
  },
  xMarkIcon: {
    fill: colors.tertiaryIcon,
    border: 'none',
    background: 'none',
    padding: 0,
    cursor: 'pointer',
    marginTop: '4px',
  },
  fields: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-20'],
    marginBottom: anatomy['size-16'],
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'end',
    gap: anatomy['space-10'],
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    paddingTop: anatomy['space-16'],
  },
});
